// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAXAnhi9QNNtSMl6MTTgHP6huq_JS-VmQM",

  authDomain: "mad-51dd2.firebaseapp.com",

  projectId: "mad-51dd2",

  storageBucket: "mad-51dd2.appspot.com",

  messagingSenderId: "492220176036",

  appId: "1:492220176036:web:53601cd56a6b26cf87f831"

};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const storage = getStorage();
